// @ts-nocheck
import React, { FC } from 'react';
import Helmet from 'react-helmet';

import useIsClient from 'Shared/Hooks/useIsClient';

type ResourceProps = {
  resource: {
    attachment: string;
    cardImageUrl: string;
    category: string;
    createdAt: string;
    publicationDate: string;
    coverUrl: string;
    description: string;
    downloadUrl: string;
    downloads: number;
    duration: number;
    isLiked: boolean;
    likes: number;
    originalId: number;
    richContent: string;
    resourceCategory: {
      slug: string;
      name: string;
    };
    resourceimageSet: Array<{
      node: {
        imageUrl: string;
        originalId: number;
      };
    }>;
    coverImages: Array<{
      imageUrl?: string;
      originalId?: string;
    }>;
    slug: string;
    tags: string[];
    title: string;
    user: {
      firstName: string;
      lastName: string;
      originalId: number;
      profilePictureUrl: string;
      profileUrl: string;
      username: string;
      occupation: string;
    };
    videoUrl: string;
    views: number;
  };
};

const getContent = (resource: ResourceProps['resource']) => {
  const url = `${location.origin}${location.pathname}`;
  const authorFullName = `${resource.user.firstName} ${resource.user.lastName}`;

  return {
    '@context': 'https://schema.org',
    '@type': 'NewsArticle',
    headline: resource.title,
    name: resource.title,
    image: resource.coverUrl,
    datePublished: resource.createdAt,
    dateModified: resource.publicationDate,
    description: resource.description,
    articleBody: resource.richContent,
    url,
    mainEntityOfPage: url,
    identifier: `crehana-resource-${resource.originalId}`,
    keywords: resource.tags,
    author: {
      '@type': 'Person',
      name: authorFullName,
      image: resource.user.profilePictureUrl,
    },
    creator: {
      '@type': 'Thing',
      name: authorFullName,
    },
    publisher: {
      '@type': 'Organization',
      name: 'Crehana',
      url: 'https://www.crehana.com/',
      logo: {
        '@type': 'ImageObject',
        width: 1200,
        height: 628,
        url: 'https://static.crehana.com/static/img/logo/logo-crehana.png',
      },
    },
  };
};

const Resource: FC<ResourceProps> = ({ resource }) => {
  const isClient = useIsClient();

  if (!isClient || !resource) {
    return null;
  }

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(getContent(resource))}
      </script>
    </Helmet>
  );
};

export default Resource;
